
window.addEventListener('load', init, false);

function init () {

	const el = document.querySelectorAll('.signup-form,#edit-form,#contact-form,#edit-form,#register-form')

	if(!el || !el.length) return

    const script = document.querySelector('[data-nocaptcha]')
    const key = script.getAttribute('src').split('=')[1]

    function getCaptchaToken(form) {
        grecaptcha.execute(key, { action: 'submit' })
            .then(token => {

                prepareForm(form)

                const data = getFormData(form)
                data.append('token', token);

                sendFormData(form.action, data)
                    .then(res => res.json())
                    .then(res => {
                        handleFormSubmission(res, form)
                    })
            })
    }

    function getFormData(form) {
		const els = form.elements;
		const data = new FormData();
		for (let i = 0 ; i < els.length; i++) {
			if (els[i].type !== "submit") {
				data.append(els[i].name, els[i].value)
            }
        }
        return data;
    }

    function getMessage(form) {
		let message = form.querySelector('.message')

        if(!message) {
            message = form.querySelector('.form-message')
        }
        return message
    }

    function prepareForm(form) {
		const message = getMessage(form)

		form.classList.add('loading')
        message.classList.remove('error')
        message.classList.remove('success')
        message.classList.remove('show')
        message.textContent = '';
    }

    function sendFormData(path, data) {
		return fetch(path, {
			method: 'POST',
			body: data,
			headers: {
				"Accept": "application/json; charset=utf-8",
				"x-requested-with": "XMLHttpRequest"
			},
		})
    }

    function handleFormSubmission(res, form) {
		const message = getMessage(form)

        if(res.success === false) {
            message.classList.add('show')
            message.classList.add('error')
            message.classList.remove('success')
            message.textContent = res.error.message
        } else {
            message.classList.add('show')
            message.classList.add('success')
            message.classList.remove('error')
            message.textContent = 'Thank you for subscribing'
        }

        form.classList.remove('loading')
    }

	function submitForm(e) {
		const form = e.target;
		e.preventDefault()

        grecaptcha.ready(() => {
            getCaptchaToken(form)
        })
	}

	el.forEach(function(item) {
		item.addEventListener("submit", submitForm, false);
	});


    // Password matching - old code

    const signupForm = document.querySelector('#register-form')

    if(signupForm) {
        let password = document.getElementById("password")
        let confirm = document.getElementById("password-confirm")

        function validatePassword(){
            if(password.value != confirm.value) {
                confirm.setCustomValidity("Passwords don't match");
            } else {
                confirm.setCustomValidity('');
            }
        }

        password.onchange = validatePassword;
        confirm.onkeyup = validatePassword;
    }

    const editForm = document.querySelector('#edit-form')

    if(editForm) {
        let password = document.getElementById("password")
        let confirm = document.getElementById("password-confirm")

        function validatePassword(){
            if(password.value != confirm.value) {
                confirm.setCustomValidity("Passwords don't match");
            } else {
                confirm.setCustomValidity('');
            }
        }

        password.onchange = validatePassword;
        confirm.onkeyup = validatePassword;
    }
}
